/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {Karen} from "../../Karen";
import {TimelineLite} from "gsap/gsap-core";
import {GameHelper} from "../../../core/utils/GameHelper";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KarenParsedGameData} from "../../server/data/KarenParsedGameData";
import {KarenSymbol} from "../../symbol/KarenSymbol";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";

export class BillBoardController extends WinPresentationController {

    constructor() {
        super("BillBoardController", false);
    }

    protected hasWin(): boolean {
        if( GameHelper.isFreeSpin(Karen.model.parsedGameData.nextMode) ) {
            for (let reelId: number = 0; reelId < 6; reelId++) {
                for (let symInd: number = 0; symInd < Karen.model.parsedGameData.evaluatedArea[reelId].length; symInd++) {
                    const sym: KarenSymbol = Karen.reels[reelId].getSymbol(symInd, false, false);
                    sym.stopWin();
                }
            }
        }
        return GameHelper.isFreeSpin(Karen.model.parsedGameData.mode) && GameHelper.isFreeSpin(Karen.model.parsedGameData.nextMode);
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = gsap.timeline();
        let delay: number = 0.01;
        let duration: number = Karen.billBoardAnimation.fetchDuration("wild_pump");
        tl.to(this, {duration: delay});
        const data: KarenParsedGameData = Karen.model.parsedGameData;
        if (Karen.model.parsedGameData.symbolSizes[5][0] > 1 || Karen.model.parsedGameData.doReelNudge) {
            let position: number = 0.2;
            tl.add(() => {
                Karen.background.addNudgeToSize(0);
                Karen.billBoardAnimation.playWildAndWin("wild_pump");
                KarenSoundManager.playSoundEffect(KarenSoundConfig.MULTIPLIER_UP);
            }, position);
            tl.add(() => {
            }, duration);
        } else {
            if (data.singleWin > 0) {
                let position = tl.totalDuration();
                tl.add(() => {
                    Karen.billBoardAnimation.playAnimation("x_up");
                    Karen.stickyXWView.playStickyBurgerWinAnimation();
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_STICKY_RESET);
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.MULTIPLIER_UP);
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_STICKY_WIN);
                }, position);
                tl.add(() => {
                    Karen.background.incrementxWayBy1();
                    Karen.xwaysMultiplierView.increaseFSxWaysSize = true;
                },position+0.1);
            } else {
                tl.add([
                    Karen.stickyXWView.playStickyBurgerNoWinAnimation(),
                ()=>{
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_STICKY_RESET);
                }
                ]);
            }
        }
        Karen.background.onSpinStart();
        tl.to(this, {duration: delay});
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            resolve();
            this.close();
        });
    }

    protected close(): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        tl.add(gsap.to(this, {duration: 0.01, alpha: 0}));
        tl.add(() => {
        });
        return tl;
    }
}
